

/**
 * It takes a list of concepts, and if the concept has an investmentDistribution of length 2, it adds
 * two new elements to the investmentDistribution.
 * @returns An array of objects.
 */

export const syncAllyWithConcept = data => {
  if (!data) return
  const { alliedOne, alliedTwo, concepts } = data?.BudgetSubmission || {}
  const numberOfAllies = (alliedOne?.length > 0 ? 1 : 0) + (alliedTwo?.length > 1 ? 1 : 0)

  if (numberOfAllies === 0) return concepts

  const newConcepts = concepts?.map(concept => {
    if (numberOfAllies === 1) {
      const newInvestment = concept.investmentDistribution.filter(el => (
        (alliedOne?.length > 0 && el.type !== "ALLIED2") || (alliedTwo?.length > 0 && el.type !== "ALLIED1")
      ))
      if (newInvestment.length === 2 && alliedOne.length) {
        newInvestment.push({
          name: alliedOne,
          type: "ALLIED1",
          percentage: 0
        })
      } else if (newInvestment.length === 2 && alliedTwo.length) {
        newInvestment.push({
          name: alliedTwo,
          type: "ALLIED2",
          percentage: 0
        })
      }
      return {
        ...concept,
        investmentDistribution: newInvestment
      }
    }
    if (numberOfAllies === 2) return concept?.investmentDistribution?.length <= 2 ? {
      ...concept,
      investmentDistribution: [
        ...concept.investmentDistribution,
        {
          name: alliedOne,
          type: "ALLIED1",
          percentage: 0
        },
        {
          name: alliedTwo,
          type: "ALLIED2",
          percentage: 0
        }
      ]
    } : concept?.investmentDistribution?.length === 2 + numberOfAllies ?
      concept : {
        ...concept,
        investmentDistribution: fixInvestmentDistribution(concept.investmentDistribution, alliedOne, alliedTwo)
      }
  })
  return newConcepts
}


/**
 * If the investmentDistribution array does not contain an object with the name of alliedOne or
 * alliedTwo, then add an object with the name of alliedOne or alliedTwo to the investmentDistribution
 * array.
 * @param investmentDistribution - [{name: "Allied1", type: "ALLIED1", percentage: 0.5}, {name:
 * "Allied2", type: "ALLIED2", percentage: 0.5}]
 * @param alliedOne - "ALLIED1"
 * @param alliedTwo - "ALLIED2"
 * @returns The newInvestment variable is being returned.
 */

const fixInvestmentDistribution = (investmentDistribution, alliedOne, alliedTwo) => {
  const newInvestment = investmentDistribution

  const allyOneExists = investmentDistribution.find(investment => investment.name === alliedOne)
  allyOneExists ? null : newInvestment.push({
    name: alliedOne,
    type: "ALLIED1",
    percentage: 0
  })

  const allyTwoExists = investmentDistribution.find(investment => investment.name === alliedTwo)
  allyTwoExists ? null : newInvestment.push({
    name: alliedTwo,
    type: "ALLIED2",
    percentage: 0
  })

  return newInvestment
}